import { SaveActionButtonsComponent } from '../../../components/save-action-buttons/save-action-buttons.component';
import { SaveActionButton } from '../../../components/save-action-buttons/save-action-button.model';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import {
  NgbDropdownModule,
  NgbNavContent,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavModule,
  NgbNavOutlet,
  NgbScrollSpy,
  NgbScrollSpyFragment,
} from '@ng-bootstrap/ng-bootstrap';
import {
  ConfigStateService,
  LocalizationModule,
  LocalizationService,
  SubscriptionService,
} from '@abp/ng.core';
import {
  Component,
  computed,
  effect,
  inject,
  Injector,
  OnInit,
  Signal,
  ViewChild,
} from '@angular/core';
import {
  CreateUpdateCustomerProjectDto,
  CustomerProjectDefaultValueDto,
  CustomerProjectDto,
  CustomerProjectHierarchyDto,
  CustomerProjectService,
  DayBookService,
  DocHierarchyDto,
  ProjectStatus,
} from '@digiwall/goliath-documents/proxy';
import { CustomerQuoteToPurchaseOrderService } from '../../quotes/quote-detail/quote-to-order.service';
import { AsyncPipe, CommonModule } from '@angular/common';
import {
  AutoSizedDropdownDirective,
  CounterComponent,
  DialogBoxComponent,
  DropdownMenu,
  DropdownMenuComponent,
  PanelComponent,
  SidePanelComponent,
} from '@digiwall/ui-kit';
import {
  DwGridDetailNavigationComponent,
  DwScrollSpyDirective,
  DwTabsComponent,
} from '@digiwall/ag-grid';
import {
  ChatComponent,
  DeactivatableComponentService,
  DwApiSelectDirective,
  DwInputRequiredDirective,
  DwKeyboardShortcutDirective,
  DwNavLinkDirective,
  DwReadonlyFormDirective,
  HistoryComponent,
} from '@digiwall/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocCustomerAddressesComponent } from '../../base-docs/detail/doc-customer-addresses/doc-customer-addresses.component';
import { AnnexesListComponent, AnnexType, CompanySiteStore } from '@digiwall/goliath-core';
import { ReportViewerComponent } from '@odyssey/reporting';
import { NgSelectModule } from '@ng-select/ng-select';
import { BaseCustomerDocDetail } from '../../base-customer-docs/base-customer-doc-detail';
import { ClassificationTypeService, DocRole, ThirdPartyRole } from '@digiwall/goliath-core/proxy';
import { DocReportPermission } from '@digiwall/goliath-documents/config';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import { BreadcrumbService } from 'xng-breadcrumb';
import { CustomerService } from '@digiwall/goliath-contacts/proxy';
import { DocTemplateService } from '../../base-docs/detail/doc-template-selection/doc-template.service';
import CustomerProjectLinesEditorComponent from './customer-project-lines/customer-project-lines-editor.component';
import { DocOrigin, GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types';
import { CustomerProjectDocumentAnnexesListComponent } from '../../../plugins/customer-project-document-annexes-list/customer-project-document-annexes-list.component';
import { CustomerProjectActivityComponent } from '@digiwall/goliath-contacts';
import { CustomerProjectSidePanelComponent } from './customer-project-side-panel/customer-project-side-panel.component';
import { SalesPersonStore } from '@digiwall/goliath-contacts';
import { DocCustomerProjectHierarchyComponent } from '../customer-project-hierarchy/customer-project-hierarchy.component';
import { CustomerProjectHierarchyGlobalViewComponent } from './customer-project-hierarchy-global-view/customer-project-hierarchy-global-view.component';
import { CustomerProjectHierarchyStatusService } from './customer-project-hierarchy-status.service';
import { DocSaveRequestContext } from '../../base-docs/detail/doc-save-request-context';
import { Observable, of } from 'rxjs';
import { QuoteAddThirdPartyComponent } from '../../quotes/quote-detail/quote-add-third-parties/quote-add-third-party.component';
import { LabelPrinterHelper } from '@digiwall/goliath-products';
import { ProductionFeatureDefinition } from '@digiwall/goliath-products/config';
import { DocumentCustomerDateCardComponent } from '../../../components';
import { AllDocumentsWithProjectsListComponent } from '../../document-list/all-docs-with-projects/all-docs-with-projects-list.component';

@Component({
  selector: 'document-customer-project-detail',
  templateUrl: './customer-project-detail.component.html',
  styleUrl: './customer-project-detail.component.scss',
  providers: [DocTemplateService, SubscriptionService, CustomerQuoteToPurchaseOrderService],
  imports: [
    CommonModule,
    PanelComponent,
    DwTabsComponent,
    NgbNavModule,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    DwNavLinkDirective,
    NgbNavContent,
    NgbScrollSpy,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    DwKeyboardShortcutDirective,
    NgbScrollSpyFragment,
    DwScrollSpyDirective,
    DocCustomerAddressesComponent,
    AnnexesListComponent,
    NgbDropdownModule,
    NgbNavOutlet,
    SaveActionButtonsComponent,
    SidePanelComponent,
    FormsModule,
    DialogBoxComponent,
    ReportViewerComponent,
    AsyncPipe,
    LocalizationModule,
    CounterComponent,
    ChatComponent,
    DwGridDetailNavigationComponent,
    DwInputRequiredDirective,
    NgSelectModule,
    DropdownMenuComponent,
    HistoryComponent,
    CustomerProjectLinesEditorComponent,
    CustomerProjectDocumentAnnexesListComponent,
    CustomerProjectActivityComponent,
    CustomerProjectSidePanelComponent,
    DwReadonlyFormDirective,
    DwApiSelectDirective,
    DocCustomerProjectHierarchyComponent,
    NgbScrollSpy,
    AutoSizedDropdownDirective,
    DocumentCustomerDateCardComponent,
    AllDocumentsWithProjectsListComponent,
  ],
})
export class CustomerProjectDetailComponent
  extends BaseCustomerDocDetail<
    CustomerProjectService,
    CustomerProjectDto,
    CreateUpdateCustomerProjectDto,
    CustomerProjectDefaultValueDto
  >
  implements OnInit
{
  @ViewChild('projectLineGrid') quoteLineGrid: CustomerProjectLinesEditorComponent;
  @ViewChild('report') reportViewer: ReportViewerComponent;
  @ViewChild('thirdPartySelectDirective') thirdPartySelectDirective: DwApiSelectDirective;

  readonly companySiteStore = inject(CompanySiteStore);
  readonly salesPersonStore = inject(SalesPersonStore);
  protected readonly enumerationTypeStore = inject(GoliathDocumentsEnumerationTypeStore);
  protected readonly hierarchyStatus = inject(CustomerProjectHierarchyStatusService);
  protected readonly productionFeature = inject(ProductionFeatureDefinition);

  docRole = DocRole.CustomerProject;
  protected thirdPartyRole = ThirdPartyRole;
  docOrigin = DocOrigin;

  protected allowDraft = false;
  protected fileBlobUrl: string | Blob;
  protected hierarchies: CustomerProjectHierarchyDto[] = [];

  protected activityCount = 0;
  protected docCount = 0;
  protected docAnnexCount = 0;

  override get defaultValue() {
    return Object.assign(this.baseDefaultValue, {
      projectStatus: ProjectStatus.Active,
    });
  }

  protected override saveActionBtns = computed((): SaveActionButton[] => [
    {
      label: this.localizationService.instant('::Save'),
      action: () => this.save(),
      disabled: () => !this.form.dirty,
    },
  ]);

  actions: Signal<DropdownMenu> = computed(() => ({
    groups: [
      this.baseActionsThirdPartyDoc().concat(),
      [
        {
          label: 'Doc::GenerateDocPrintTemplate',
          icon: 'digi-out-edit-square',
          action: () => this.openDesigner(),
          requiredPolicy: DocReportPermission.Create,
        },
      ],
    ],
  }));

  constructor(
    route: ActivatedRoute,
    router: Router,
    subscriptionService: SubscriptionService,
    service: CustomerProjectService,
    formBuilder: FormBuilder,
    toastService: ToasterService,
    breadcrumbService: BreadcrumbService,
    dayBookService: DayBookService,
    localizationService: LocalizationService,
    classificationTypeService: ClassificationTypeService,
    docTemplateService: DocTemplateService,
    injector: Injector,
    config: ConfigStateService,
    customerService: CustomerService,
    confirmationService: ConfirmationService,
    deactivableComponentService: DeactivatableComponentService,
    protected labelPrinterHelper: LabelPrinterHelper,
  ) {
    super(
      route,
      router,
      subscriptionService,
      service,
      formBuilder,
      toastService,
      breadcrumbService,
      dayBookService,
      localizationService,
      classificationTypeService,
      docTemplateService,
      injector,
      customerService,
      config,
      confirmationService,
      deactivableComponentService,
      labelPrinterHelper,
    );

    effect(async () => {
      if (this.entitySignal()?.id) {
        this.docService
          .getAnnexByTypeId(this.entitySignal().id, AnnexType.Logo)
          .subscribeOnce(async response => {
            if (response != null) {
              if ((<any>response.file)?.content != null) {
                this.fileBlobUrl = (<any>response.file).content;
              } else {
                (<any>response.file).content = this.fileBlobUrl =
                  (await this.fileManagementService.blobUrl(response.file)) as string;
              }
            } else {
              this.fileBlobUrl = null;
            }
          });
      }
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.init();
  }

  protected override async afterGetEntity(response: CustomerProjectDto) {
    super.afterGetEntity(response);
    this.activityCount = response.activityCount;
    this.docCount = response.docCount;
    this.docAnnexCount = response.docAnnexCount;

    if (this.entity?.id != null) {
      this.loadHierarchies();
    }
  }

  protected override validateVatSystem(
    saveRequest: DocSaveRequestContext,
  ): Observable<DocSaveRequestContext> {
    saveRequest.recomputeVatCodes = false;
    return of(saveRequest);
  }

  override get formModel() {
    return Object.assign({}, super.formModel, {
      projectStatus: [ProjectStatus.Active],
    });
  }

  loadHierarchies() {
    this.docService.hierarchies(this.docId).subscribeOnce(x => {
      this.hierarchies = x;
    });
  }

  openGlobalView() {
    const modalRef = this.modalService.open(CustomerProjectHierarchyGlobalViewComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      scrollable: true,
      injector: this.injector,
      size: 'xl',
    });

    modalRef.componentInstance.hierarchies = this.hierarchies;
  }

  protected openModelThirdPartyForm() {
    const modalRef = this.offcanvasService.open(QuoteAddThirdPartyComponent, this.injector, {
      position: 'end',
      panelClass: 'w-100 w-sm-75',
    });

    modalRef.closed.subscribeOnce(thirdpartyId => {
      this.form.get('thirdPartyId').setValue(thirdpartyId);
      this.thirdPartySelectDirective.reloadSelectedValues();
    });
  }

  protected refreshActivityCount() {
    this.docService.getActivityCount(this.entity.id).subscribeOnce(x => {
      this.activityCount = x;
    });
  }
}
